const methy_compare_DMR_paths = {
    "CA12DAP_vs_CA15DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/boxplot/CA12DAP_vs_CA15DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/boxplot/CA12DAP_vs_CA15DAP.DMR.boxplot.CHG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/boxplot/CA12DAP_vs_CA15DAP.DMR.boxplot.CHH.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/circos/CA12DAP_vs_CA15DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/circos/CA12DAP_vs_CA15DAP_CG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/circos/CA12DAP_vs_CA15DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/circos/CA12DAP_vs_CA15DAP_CHG.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/distribution/CA12DAP_vs_CA15DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/distribution/CA12DAP_vs_CA15DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/distribution/CA12DAP_vs_CA15DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/distribution/CA12DAP_vs_CA15DAP.CHH.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/distribution/CA12DAP_vs_CA15DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/distribution/CA12DAP_vs_CA15DAP.CHH.DMRs_length.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/heatmap/CA12DAP_vs_CA15DAP.DMR.heatmap.CHH.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/heatmap/CA12DAP_vs_CA15DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA15DAP/heatmap/CA12DAP_vs_CA15DAP.DMR.heatmap.CHG.png"
        ]
    },
    "CA12DAP_vs_CA9DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/boxplot/CA12DAP_vs_CA9DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/boxplot/CA12DAP_vs_CA9DAP.DMR.boxplot.CHH.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/boxplot/CA12DAP_vs_CA9DAP.DMR.boxplot.CHG.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/circos/CA12DAP_vs_CA9DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/circos/CA12DAP_vs_CA9DAP_CG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/circos/CA12DAP_vs_CA9DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/circos/CA12DAP_vs_CA9DAP.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/distribution/CA12DAP_vs_CA9DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/distribution/CA12DAP_vs_CA9DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/distribution/CA12DAP_vs_CA9DAP.CHH.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/distribution/CA12DAP_vs_CA9DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/distribution/CA12DAP_vs_CA9DAP.CHH.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/distribution/CA12DAP_vs_CA9DAP.CHG.DMRs_length.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/heatmap/CA12DAP_vs_CA9DAP.DMR.heatmap.CHH.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/heatmap/CA12DAP_vs_CA9DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_CA9DAP/heatmap/CA12DAP_vs_CA9DAP.DMR.heatmap.CHG.png"
        ]
    },
    "CA12DAP_vs_ZY12DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/boxplot/CA12DAP_vs_ZY12DAP.DMR.boxplot.CHH.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/boxplot/CA12DAP_vs_ZY12DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/boxplot/CA12DAP_vs_ZY12DAP.DMR.boxplot.CHG.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/circos/CA12DAP_vs_ZY12DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/circos/CA12DAP_vs_ZY12DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/circos/CA12DAP_vs_ZY12DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/circos/CA12DAP_vs_ZY12DAP_CG.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/distribution/CA12DAP_vs_ZY12DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/distribution/CA12DAP_vs_ZY12DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/distribution/CA12DAP_vs_ZY12DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/distribution/CA12DAP_vs_ZY12DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/distribution/CA12DAP_vs_ZY12DAP.CHH.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/distribution/CA12DAP_vs_ZY12DAP.CHH.DMRs_generegion.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/heatmap/CA12DAP_vs_ZY12DAP.DMR.heatmap.CHH.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/heatmap/CA12DAP_vs_ZY12DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/CA12DAP_vs_ZY12DAP/heatmap/CA12DAP_vs_ZY12DAP.DMR.heatmap.CHG.png"
        ]
    },
    "CA15DAP_vs_CA9DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/boxplot/CA15DAP_vs_CA9DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/boxplot/CA15DAP_vs_CA9DAP.DMR.boxplot.CHG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/boxplot/CA15DAP_vs_CA9DAP.DMR.boxplot.CHH.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/circos/CA15DAP_vs_CA9DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/circos/CA15DAP_vs_CA9DAP_CG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/circos/CA15DAP_vs_CA9DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/circos/CA15DAP_vs_CA9DAP_CHH.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/distribution/CA15DAP_vs_CA9DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/distribution/CA15DAP_vs_CA9DAP.CHH.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/distribution/CA15DAP_vs_CA9DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/distribution/CA15DAP_vs_CA9DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/distribution/CA15DAP_vs_CA9DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/distribution/CA15DAP_vs_CA9DAP.CHH.DMRs_length.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/heatmap/CA15DAP_vs_CA9DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/heatmap/CA15DAP_vs_CA9DAP.DMR.heatmap.CHG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_CA9DAP/heatmap/CA15DAP_vs_CA9DAP.DMR.heatmap.CHH.png"
        ]
    },
    "CA15DAP_vs_ZY15DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/boxplot/CA15DAP_vs_ZY15DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/boxplot/CA15DAP_vs_ZY15DAP.DMR.boxplot.CHH.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/boxplot/CA15DAP_vs_ZY15DAP.DMR.boxplot.CHG.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/circos/CA15DAP_vs_ZY15DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/circos/CA15DAP_vs_ZY15DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/circos/CA15DAP_vs_ZY15DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/circos/CA15DAP_vs_ZY15DAP_CG.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/distribution/CA15DAP_vs_ZY15DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/distribution/CA15DAP_vs_ZY15DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/distribution/CA15DAP_vs_ZY15DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/distribution/CA15DAP_vs_ZY15DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/distribution/CA15DAP_vs_ZY15DAP.CHH.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/distribution/CA15DAP_vs_ZY15DAP.CHH.DMRs_generegion.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/heatmap/CA15DAP_vs_ZY15DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/heatmap/CA15DAP_vs_ZY15DAP.DMR.heatmap.CHG.png",
            "/api/static/methy/methy_plot/CA15DAP_vs_ZY15DAP/heatmap/CA15DAP_vs_ZY15DAP.DMR.heatmap.CHH.png"
        ]
    },
    "CA9DAP_vs_ZY9DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/boxplot/CA9DAP_vs_ZY9DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/boxplot/CA9DAP_vs_ZY9DAP.DMR.boxplot.CHH.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/boxplot/CA9DAP_vs_ZY9DAP.DMR.boxplot.CHG.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/circos/CA9DAP_vs_ZY9DAP_CG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/circos/CA9DAP_vs_ZY9DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/circos/CA9DAP_vs_ZY9DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/circos/CA9DAP_vs_ZY9DAP_CHH.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/distribution/CA9DAP_vs_ZY9DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/distribution/CA9DAP_vs_ZY9DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/distribution/CA9DAP_vs_ZY9DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/distribution/CA9DAP_vs_ZY9DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/distribution/CA9DAP_vs_ZY9DAP.CHH.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/distribution/CA9DAP_vs_ZY9DAP.CHH.DMRs_length.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/heatmap/CA9DAP_vs_ZY9DAP.DMR.heatmap.CHG.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/heatmap/CA9DAP_vs_ZY9DAP.DMR.heatmap.CHH.png",
            "/api/static/methy/methy_plot/CA9DAP_vs_ZY9DAP/heatmap/CA9DAP_vs_ZY9DAP.DMR.heatmap.CG.png"
        ]
    },
    "ZY12DAP_vs_ZY15DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/boxplot/ZY12DAP_vs_ZY15DAP.DMR.boxplot.CHG.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/boxplot/ZY12DAP_vs_ZY15DAP.DMR.boxplot.CHH.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/boxplot/ZY12DAP_vs_ZY15DAP.DMR.boxplot.CG.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/circos/ZY12DAP_vs_ZY15DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/circos/ZY12DAP_vs_ZY15DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/circos/ZY12DAP_vs_ZY15DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/circos/ZY12DAP_vs_ZY15DAP_CG.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/distribution/ZY12DAP_vs_ZY15DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/distribution/ZY12DAP_vs_ZY15DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/distribution/ZY12DAP_vs_ZY15DAP.CHH.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/distribution/ZY12DAP_vs_ZY15DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/distribution/ZY12DAP_vs_ZY15DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/distribution/ZY12DAP_vs_ZY15DAP.CHH.DMRs_length.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/heatmap/ZY12DAP_vs_ZY15DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/heatmap/ZY12DAP_vs_ZY15DAP.DMR.heatmap.CHH.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY15DAP/heatmap/ZY12DAP_vs_ZY15DAP.DMR.heatmap.CHG.png"
        ]
    },
    "ZY12DAP_vs_ZY9DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/boxplot/ZY12DAP_vs_ZY9DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/boxplot/ZY12DAP_vs_ZY9DAP.DMR.boxplot.CHG.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/boxplot/ZY12DAP_vs_ZY9DAP.DMR.boxplot.CHH.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/circos/ZY12DAP_vs_ZY9DAP_CG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/circos/ZY12DAP_vs_ZY9DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/circos/ZY12DAP_vs_ZY9DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/circos/ZY12DAP_vs_ZY9DAP_CHG.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/distribution/ZY12DAP_vs_ZY9DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/distribution/ZY12DAP_vs_ZY9DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/distribution/ZY12DAP_vs_ZY9DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/distribution/ZY12DAP_vs_ZY9DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/distribution/ZY12DAP_vs_ZY9DAP.CHH.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/distribution/ZY12DAP_vs_ZY9DAP.CHH.DMRs_generegion.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/heatmap/ZY12DAP_vs_ZY9DAP.DMR.heatmap.CHG.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/heatmap/ZY12DAP_vs_ZY9DAP.DMR.heatmap.CG.png",
            "/api/static/methy/methy_plot/ZY12DAP_vs_ZY9DAP/heatmap/ZY12DAP_vs_ZY9DAP.DMR.heatmap.CHH.png"
        ]
    },
    "ZY15DAP_vs_ZY9DAP": {
        "boxplot": [
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/boxplot/ZY15DAP_vs_ZY9DAP.DMR.boxplot.CG.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/boxplot/ZY15DAP_vs_ZY9DAP.DMR.boxplot.CHH.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/boxplot/ZY15DAP_vs_ZY9DAP.DMR.boxplot.CHG.png"
        ],
        "circos": [
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/circos/ZY15DAP_vs_ZY9DAP.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/circos/ZY15DAP_vs_ZY9DAP_CHG.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/circos/ZY15DAP_vs_ZY9DAP_CHH.DMR_circos_819200.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/circos/ZY15DAP_vs_ZY9DAP_CG.DMR_circos_819200.png"
        ],
        "distribution": [
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/distribution/ZY15DAP_vs_ZY9DAP.CG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/distribution/ZY15DAP_vs_ZY9DAP.CHG.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/distribution/ZY15DAP_vs_ZY9DAP.CHH.DMRs_generegion.distribution.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/distribution/ZY15DAP_vs_ZY9DAP.CG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/distribution/ZY15DAP_vs_ZY9DAP.CHG.DMRs_length.distribution.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/distribution/ZY15DAP_vs_ZY9DAP.CHH.DMRs_length.distribution.png"
        ],
        "heatmap": [
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/heatmap/ZY15DAP_vs_ZY9DAP.DMR.heatmap.CHH.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/heatmap/ZY15DAP_vs_ZY9DAP.DMR.heatmap.CHG.png",
            "/api/static/methy/methy_plot/ZY15DAP_vs_ZY9DAP/heatmap/ZY15DAP_vs_ZY9DAP.DMR.heatmap.CG.png"
        ]
    }
}
export default methy_compare_DMR_paths